<template>
  <div class="signup">
    <p>Let's create a new account !</p>
    <input type="text" v-model="email" placeholder="Email"><br>
    <input type="password" v-model="password" placeholder="Password"><br>
    <button v-on:click="signUp">Anmelden</button>
    <span>or go back to <router-link to="/login">login</router-link>.</span>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import { db } from '../main'

export default {
  name: 'signUp',
  data: function () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    signUp: function () {
      firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
        (user) => {
          // firebase.auth().currentUser.sendEmailVerification().then(function () {
          //   self.emailVerifiedText = 'Eine Email zur Verifizierung der Adresse wurde verschickt'
          //   // Email sent.
          // }).catch(function (error) {
          //   // An error happened.
          //   self.emailVerifiedText = 'Eine Email zur Verifizierung sollte verschickt werden, aber es gab einen Fehler:' + error
          // })
          console.log(user)
          console.log(user.user)

          var uid = user.user.uid + ''
          var email = user.user.email + ''
          console.log(email)
          db.collection('users').doc(uid).set({
            email: user.user.email,
            verified: false
          })
            .then(function () {
              console.log('Document successfully written!')
            })
            .catch(function (error) {
              console.error('Error writing document: ', error)
            })

          this.$router.replace('hello')
        },
        (err) => {
          alert('Oops. ' + err.message)
        }
      )
    }
  }
}
</script>

<style scoped>
  .signup {
    margin-top: 40px;
  }
  span {
    display: block;
    margin-top: 20px;
    font-size: 11px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SignUp.vue